import * as React from 'react';
import FeedbackPageView from '../layouts/FeedbackView';
import { RowFeedbackparameters, RowFeedbackTypes } from 'src/reducers/completeorderfile';

export interface FeedbackPageProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    onSubmit: () => void;
    onReset: () => void;
    onResetFbParams: () => void;

    saveComments: (comments: string) => void;
    saveRating: (rating: number) => void;
    saveFbType: (fbtype: string) => void;

    totalRating: number;
    comments: string;
    fbtype: string;
    submitFbFiles: Array<File>;
    deleteRowbyId: () => void;
    onFilesError: (error: Error, images: Array<File>) => void;
    onFilesChange: (submitFbFiles: Array<File>) => void;
    handleCheckboxChange: (value: string, list: string, checked: boolean) => void;
    checkedValuesGeneral: () => void;
    checkedValuesAnterior: () => void;
    checkedValuesCopings: () => void;
    checkedValuesModel: () => void;
    checkedValuesAbutment: () => void;
    checkedValuesCutback: () => void;

    orderno: string;
    orderdate: string;
    completedon: string;
    tat: string;
    fname: string;
    tool_preferred: string;
    destination: string;
    modelonly: string;
    approval_reqd: string;
    bravopremium: string;
    nounits: string;
    feedbackparameters: RowFeedbackparameters[];
    feedbacktypes: RowFeedbackTypes[];
    selectedCheckedParameters?: { [key: string]: string[] };
    updateSelectedCheckedParameters?: (selectedCheckedParameters: { [key: string]: string[] }) => void;
}

class FeedbackPage extends React.Component<FeedbackPageProps, { selectedCheckedParameters: { [key: string]: string[] } }> {
    constructor(props: FeedbackPageProps) {
        super(props);
        this.state = {
            selectedCheckedParameters: {}
        };
    }

    updateSelectedCheckedParameters = (selectedCheckedParameters: { [key: string]: string[] }) => {
        this.setState({ selectedCheckedParameters });
    }

    handleReset = () => {
        this.setState({ selectedCheckedParameters: {} });
        this.props.onReset();
    }
    render() {
        return (
            <div>
                <FeedbackPageView
                    saveComments={this.props.saveComments}
                    onSubmit={this.props.onSubmit}
                    saveRating={this.props.saveRating}
                    // onReset={this.props.onReset}
                    onReset={this.handleReset}
                    onResetFbParams={this.props.onResetFbParams}
                    totalRating={this.props.totalRating}
                    comments={this.props.comments}
                    fbtype={this.props.fbtype}
                    submitFbFiles={this.props.submitFbFiles}
                    onFilesChange={this.props.onFilesChange}
                    onFilesError={this.props.onFilesError}
                    deleteRowbyId={this.props.deleteRowbyId}
                    checkedValuesGeneral={this.props.checkedValuesGeneral}
                    handleCheckboxChange={this.props.handleCheckboxChange}
                    checkedValuesAnterior={this.props.checkedValuesAnterior}
                    checkedValuesCopings={this.props.checkedValuesCopings}
                    checkedValuesModel={this.props.checkedValuesModel}
                    checkedValuesAbutment={this.props.checkedValuesAbutment}
                    checkedValuesCutback={this.props.checkedValuesCutback}
                    orderno={this.props.orderno}
                    orderdate={this.props.orderdate}
                    completedon={this.props.completedon}
                    tat={this.props.tat}
                    fname={this.props.fname}
                    tool_preferred={this.props.tool_preferred}
                    destination={this.props.destination}
                    modelonly={this.props.modelonly}
                    approval_reqd={this.props.approval_reqd}
                    bravopremium={this.props.bravopremium}
                    nounits={this.props.nounits}
                    fbparameters={this.props.feedbackparameters}
                    fbtypes={this.props.feedbacktypes} 
                    saveFbType={this.props.saveFbType}
                    selectedCheckedParameters={this.state.selectedCheckedParameters}
                    updateSelectedCheckedParameters={this.updateSelectedCheckedParameters}
                />
            </div>
        );
    }
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default FeedbackPage;



// WEBPACK FOOTER //
// ./src/components/feedback/FeedbackPage.tsx